
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { login, logout, verifyOtp ,getWebsiteBySubdomain} from '../thunkMidddleware/authMiddleware';
import { AuthState, User } from '@/types/AuthTypes';
import BaseApiState from "@/api/BaseApiState"
import { Values } from '@/constants/Values';

const initialState: AuthState = {
  user:  sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')): null,
  token: sessionStorage.getItem( Values.jwtTokenV2) || '',
  isAuthenticated: !!sessionStorage.getItem(Values.jwtTokenV2),
  isLoading: false,
  error: null,
  success: false,
  getWebsiteBySubdomainResponse:BaseApiState
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    clearCredentials: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false
      })
      .addCase(login.fulfilled, (state, action) => {
        let { payload } = action.payload

        if (payload?.token) {
          sessionStorage.setItem(Values.jwtTokenV2 , payload?.token);
        }
        if(payload?.user){
          sessionStorage.setItem("user", JSON.stringify(payload?.user));
        }
        state.isLoading = false;
        state.token = payload?.token;
        state.user = payload?.user;
        state.isAuthenticated =  payload?.token?true:false;
        state.success = true;

      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action?.error as string;
        state.success = false
      });

      // ---------------------------------------------------------------------------
      builder
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        let { payload } = action.payload

        if (payload?.token) {
          sessionStorage.setItem( Values.jwtTokenV2 , payload?.token);
        }
        if(payload?.user){
          sessionStorage.setItem("user", JSON.stringify(payload?.user));
        }
        state.isLoading = false;
        state.token = payload?.token;
        state.user = payload?.user;
        state.isAuthenticated =  payload?.token?true:false;
        state.success = true;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action?.error as string;
        state.success = false
      });

     // ---------------------------------------------------------------------------

      builder
            .addCase(getWebsiteBySubdomain.pending, (state) => {
                state.getWebsiteBySubdomainResponse.isLoading = true;
                state.getWebsiteBySubdomainResponse.error = null;
            })
            .addCase(getWebsiteBySubdomain.fulfilled, (state, action) => {
                state.getWebsiteBySubdomainResponse.isLoading = false;
                state.getWebsiteBySubdomainResponse.success = action.payload?.success;
                state.getWebsiteBySubdomainResponse.payload = action.payload?.payload;
            })
            .addCase(getWebsiteBySubdomain.rejected, (state, action) => {
                state.getWebsiteBySubdomainResponse.isLoading = false;
                state.getWebsiteBySubdomainResponse.error = action.error as string;
                state.getWebsiteBySubdomainResponse.payload = null
            });
  },
});

export const { setCredentials, clearCredentials, clearError } = authSlice.actions;

export default authSlice.reducer;
